import { render, staticRenderFns } from "./DatiOccupanti.vue?vue&type=template&id=347adf09&scoped=true&"
import script from "./DatiOccupanti.vue?vue&type=script&lang=js&"
export * from "./DatiOccupanti.vue?vue&type=script&lang=js&"
import style0 from "./DatiOccupanti.vue?vue&type=style&index=0&id=347adf09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347adf09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})
